<script setup lang="ts">
import { registerFormRouteGuard } from '@/composables/routerGuard'
import { udpateProfilAdresse } from '@/helpers/globals'
import type { Adresse } from '@/models/Adresse'
import AdresseForm from '@/views/auth/adressen/AdressenForm.vue'
import { ref, type Ref } from 'vue'
import { useRouter } from 'vue-router'

registerFormRouteGuard(isDirty)
const router = useRouter()

const adresseForm: Ref<typeof AdresseForm | null> = ref(null)

const address: Ref<Adresse | null> = ref(null)

function onRecordChange(rec: Adresse | null) {
    address.value = rec
}

function isDirty() {
    return adresseForm.value?.isDirty()
}
</script>

<template>
    <div>
        <AdresseForm
            ref="adresseForm"
            @update:address="onRecordChange"
            @reloadProfile="udpateProfilAdresse()"
            @close="router.go(-1)"
        />
    </div>
</template>
